import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectTabPreco, getTabPreco } from '../../store/Preco';
import Select, { components } from 'react-select';
const { ValueContainer, Placeholder } = components;

const SelectTabelaPreco = ({ initialValue }) => {
  const { optionsSelect, selectTabelaPreco } = useSelector(state => state.precoReduce);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTabPreco());
    if (initialValue) {
      dispatch(selectTabPreco(initialValue));
    }
  }, [dispatch, initialValue]);

  const CustomValueContainer = ({ children, ...props }) => {
    return (
      <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.isFocused}>
          {props.selectProps.placeholder}
        </Placeholder>
        {React.Children.map(children, (child) =>
          child && child.type !== Placeholder ? child : null
        )}
      </ValueContainer>
    );
  };
  return (
    <div className="w-full">
      <Select
        value={
          optionsSelect.find(
            opt => String(opt.value) === String(selectTabelaPreco?.codTabPreco)
          ) || null
        }
        onChange={(e) => dispatch(selectTabPreco(e?.value || null))}
        isClearable={true}
        isSearchable={true}
        options={optionsSelect}
        components={{
          ValueContainer: CustomValueContainer
        }}
        placeholder="Tabela de Preço"
        styles={{
          container: (provided, state) => ({
            ...provided,
            marginTop: 10
          }),
          valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible",
            marginTop: 20
          }),
          placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: -15,
            backgroundColor: "transparent",
            fontSize: 14
          })
        }}
      />
    </div>
  );
};

export default SelectTabelaPreco;